<template>
    <div class="row">
        <div class="col s12 m12">
            <div class="row pt-15">
                <div class="input-field col s5 m3">
                    <label>Search</label>
                    <input type="text" v-model="search_member" placeholder="Members Name">
                </div>
            </div>

            <div class="row">
                <div class="card-panel col s12">
                    <div class="row">
                        <!-- Member selections -->
                        <div class="col s12 m12">
                            <table class="members_table">
                                <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Month</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="member in filteredPendingMembers" v-bind:class="{ 'odd-grouping': !member.group }">
                                    <td>{{ member.name }}</td>
                                    <td>{{ member.full_period }}</td>
                                    <td>
                                        <button
                                                class="waves-effect waves-light blue btn"
                                                v-on:click="sendNotification(member)"
                                        >
                                            Send notification
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div id="notification_modal" class="modal">
            <div class="modal-content">
                <h4>Send Email Notification to <b>{{ send_member.name }}</b></h4>
                <p>Remind for stress score submission at <b>{{ send_member.full_period }}</b></p>
            </div>
            <div class="modal-footer">
                <a href="#!" class="modal-close btn-flat waves-effect waves-green">Cancel</a>

                <a href="#!" v-on:click="postSendNotification" class="btn waves-effect waves-green" :disabled="loading">
                    <span v-show="!loading">Agree</span>
                    <span v-show="loading">
                        <div class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-yellow-only" style="border-color: #252525 !important;">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                    </span>
                </a>

                <div></div>
            </div>
        </div>
    </div>

</template>

<script>
  import axios from 'axios'

  export default {
    name: 'PendingStressScoreComponent',

    props : {
      dataPendingStressScoreUrl: String,
      postSendNotificationUrl: String
    },

    data() {
      return {
        pending_members: [],
        search_member: '',
        loading: false,

        send_member: {
          id: null,
          name: null,
          full_period: null,
          month: null,
          year: null,
          group: null
        }
      }
    },

    computed: {
      filteredPendingMembers () {
        if (this.search_member !== '') {
          return this.pending_members.filter((item) => {
            return item.name.toLowerCase().includes(this.search_member.toLowerCase());
          });
        } else {
          return this.pending_members;
        }
      }
    },

    mounted () {
      this.load();
    },

    methods: {
      load() {
        axios.post(this.dataPendingStressScoreUrl)
          .then((res) => {
            this.pending_members = res.data.data;
          });

      },

      sendNotification (member) {
        this.send_member = member;

        let modal = M.Modal.getInstance($('#notification_modal'));
        modal.open();
      },

      postSendNotification() {
        let modal = M.Modal.getInstance($('#notification_modal'));
        this.loading = true;

        axios.post(this.postSendNotificationUrl, this.send_member)
          .then((res) => {
            this.loading = false;

            if (res.data.success) {
              M.toast({html: res.data.messages, classes: 'toast-background-color'});
            } else {
              M.toast({html: res.data.messages, classes: 'red accent-2'});
            }
            modal.close();
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
    .members_table {
        tbody {
            display: block;
            max-height: 45vh;
            overflow-y: scroll;

            tr {

                &.odd-grouping {
                    background-color: #eaeaea;
                }

            }
        }

        thead, tbody tr {
            display: table;
            width: 100%;
            table-layout: fixed;
        }
    }

    #notification_modal {

        h4 {
            font-weight: 400 ;
        }

        text-align: center;

        .modal-footer {
            a {
                padding: 0 2em;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/scores/admin/PendingStressScoreComponent.vue